/// <reference types="./sampleEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { queryMany } from '../QueryFunctions.js';
import { sampleAdminEntitiesQuery, } from '../search/QueryGenerator.js';
import { assertIsDefined } from '../utils/AssertUtils.js';
import { resolveAdminEntityInfo, resolveEntityFields } from '../utils/CodecUtils.js';
export async function adminEntitySampleEntities(database, schema, context, query, offset, limit, resolvedAuthKeys) {
    const sqlQueryResult = sampleAdminEntitiesQuery(schema, query, offset, limit, resolvedAuthKeys);
    if (sqlQueryResult.isError())
        return sqlQueryResult;
    const searchResult = await queryMany(database, context, sqlQueryResult.value);
    if (searchResult.isError())
        return searchResult;
    const entitiesValues = searchResult.value;
    return ok(entitiesValues.map((it) => {
        assertIsDefined(it.uuid);
        return {
            ...resolveAdminEntityInfo(it),
            ...resolveEntityFields(it),
            id: it.uuid,
        };
    }));
}
//# sourceMappingURL=sampleEntities.js.map